<template>
    <div v-if="dialogVisible" class="modal-mask policy-bill__modal">
        <div class="custom-modal-wrapper">
            <div class="custom-modal-container">
                <div class="policy-bill">
                    <div v-if="this.preloader" class="modal-preloader">
                        <div class="spinner"></div>
                    </div>
                    <div class="policy-bill__heading">Оберіть варіант оплати</div>
                    <hr class="hr-grey">
                    <a href="javascript:void(0)" @click="close()" class="hide">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 1L1 17" stroke="black" stroke-width="2"/>
                            <path d="M1 1L17 17" stroke="black" stroke-width="2"/>
                        </svg>
                    </a>
                    <template v-for="paidBy in ['client', 'agent', 'uinsure']">
                      <button
                        :key="`liqpay_${paidBy}`"
                        v-if="!$store.getters.USER.organizationId
                          && isPaymentSystemEnable('liqpay', paidBy)
                          && isAcquireCommissionMayBePaid('liqpay', paidBy)
                          && !isPaymentWayUnavailable('liqpay', paidBy)"
                        @click="showModalGetInvoiceOrder('liqpay', paidBy)"
                        class="btn btn-warning payments-ways-btn"
                        type="button"
                      >
                          <span class="payments-icon">
                          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.11511 25.2118L0.754317 24.903C-0.124429 24.1527 -0.278858 22.7847 0.521989 21.9059L9.9217 11.1628C10.672 10.2841 12.04 10.1297 12.9187 10.9305L13.2795 11.2407C14.1583 11.9896 14.3127 13.359 13.5118 14.2364L4.11214 24.9795C3.36186 25.8582 2.04579 25.9607 1.11511 25.2118Z" fill="url(#paint0_linear_429_676)"/>
                              <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M8.65769 13.0229L8.47593 12.8151L7.03003 14.4688L7.18446 14.6491C9.6649 17.1282 8.60576 19.6333 8.03724 20.512L8.2436 20.2797C8.57979 19.8916 9.09638 19.2984 9.63757 18.6534C10.2061 17.6708 11.0069 15.3461 8.65769 13.0229Z" fill="url(#paint1_linear_429_676)"/>
                              <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M11.7556 16.2508L12.1437 15.8121C12.1697 15.7602 12.2202 15.7082 12.2462 15.6563C11.8335 16.121 11.3948 16.613 10.9807 17.1022C11.2909 16.7674 11.5492 16.4831 11.7556 16.2508Z" fill="url(#paint2_radial_429_676)"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5652 11.4976L4.16277 0.755892C3.41386 -0.12422 2.04449 -0.280016 1.16711 0.523565L0.806319 0.831057C-0.0724267 1.57997 -0.226856 2.94934 0.573991 3.82672L8.50184 12.8137L8.68223 13.0214C11.0328 15.372 10.232 17.6953 9.63888 18.6766C10.1035 18.134 10.5682 17.5915 11.0069 17.1008C11.421 16.6102 11.8597 16.1196 12.2724 15.6549C12.6865 15.1903 13.0732 14.7516 13.3315 14.466C14.2349 13.5886 14.3647 12.375 13.5639 11.4976H13.5652Z" fill="url(#paint3_linear_429_676)"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0472 25.2118L12.6864 24.903C11.8077 24.1527 11.6533 22.7847 12.4541 21.9059L21.8538 11.1628C22.6027 10.2841 23.9721 10.1297 24.8495 10.9305L25.2116 11.2407C26.089 11.9896 26.2448 13.359 25.444 14.2364L16.0429 24.9795C15.294 25.8582 13.9779 25.9607 13.0472 25.2118Z" fill="url(#paint4_linear_429_676)"/>
                              <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M20.6921 12.9189L20.5117 12.7126L19.0645 14.3662L19.2202 14.5466C21.6993 17.0257 20.6415 19.5307 20.0717 20.4095L20.2794 20.1771C20.6142 19.789 21.1308 19.1945 21.6734 18.5495C22.2419 17.5682 23.0427 15.2422 20.6921 12.9189Z" fill="url(#paint5_linear_429_676)"/>
                              <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M23.6616 16.2508L24.0497 15.8121C24.0743 15.7602 24.1263 15.7082 24.1522 15.6563C23.7395 16.121 23.3008 16.613 22.8867 17.1022C23.1969 16.7674 23.4812 16.4831 23.6616 16.2508Z" fill="url(#paint6_radial_429_676)"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M25.4699 11.4976L16.0688 0.755892C15.3199 -0.12422 13.9519 -0.280016 13.0731 0.523565L12.7123 0.831057C11.8336 1.58134 11.6791 2.95071 12.48 3.82809L20.4078 12.8151L20.5882 13.0228C22.9388 15.3734 22.138 17.6967 21.5449 18.6779C22.0095 18.1354 22.4742 17.5928 22.9129 17.1022C23.3256 16.6116 23.7657 16.121 24.1784 15.6563C24.5911 15.1917 24.9792 14.753 25.2375 14.4673C26.1409 13.59 26.2707 12.375 25.4699 11.4976Z" fill="url(#paint7_linear_429_676)"/>
                              <defs>
                                  <linearGradient id="paint0_linear_429_676" x1="1.72406" y1="21.699" x2="12.8134" y2="15.3052" gradientUnits="userSpaceOnUse"><stop stop-color="#1FADC3"/><stop offset="0.7072" stop-color="#36B98F"/></linearGradient>
                                  <linearGradient id="paint1_linear_429_676" x1="8.56835" y1="15.7463" x2="9.70895" y2="14.7936" gradientUnits="userSpaceOnUse"><stop stop-color="#123F06" stop-opacity="0"/><stop offset="1" stop-color="#123F06"/></linearGradient>
                                  <radialGradient id="paint2_radial_429_676" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(6.57513 15.5966) scale(6.29702 6.29532)"><stop offset="0.4185" stop-color="#123F06" stop-opacity="0"/><stop offset="1" stop-color="#123F06"/></radialGradient>
                                  <linearGradient id="paint3_linear_429_676" x1="2.22148" y1="4.5117" x2="12.2161" y2="10.6221" gradientUnits="userSpaceOnUse"><stop stop-color="#9FDB57"/><stop offset="1" stop-color="#71CA5E"/></linearGradient>
                                  <linearGradient id="paint4_linear_429_676" x1="13.6466" y1="21.7056" x2="24.7358" y2="15.3121" gradientUnits="userSpaceOnUse"><stop stop-color="#1FADC3"/><stop offset="0.7072" stop-color="#36B98F"/></linearGradient>
                                  <linearGradient id="paint5_linear_429_676" x1="20.6034" y1="15.6437" x2="21.744" y2="14.6907" gradientUnits="userSpaceOnUse"><stop stop-color="#123F06" stop-opacity="0"/><stop offset="1" stop-color="#123F06"/></linearGradient>
                                  <radialGradient id="paint6_radial_429_676" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(18.4918 15.5966) scale(6.29702 6.29532)"><stop offset="0.4185" stop-color="#123F06" stop-opacity="0"/><stop offset="1" stop-color="#123F06"/></radialGradient>
                                  <linearGradient id="paint7_linear_429_676" x1="14.1318" y1="4.5167" x2="24.1269" y2="10.6269" gradientUnits="userSpaceOnUse"><stop stop-color="#9FDB57"/><stop offset="1" stop-color="#71CA5E"/></linearGradient>
                              </defs>
                          </svg>
                          </span>
                          Рахунок на оплату LiqPay
                          <span
                            v-if="isAcquireCommissionMayBePaid('liqpay', paidBy)"
                            class="payment_notice"
                          >
                            {{ paidBy === 'uinsure'
                                ? 'Комісія не стягується'
                                : `Комісію ${getAcquireCommission('liqpay')}% оплачує ${isAcquireCommissionPayAgent(paidBy) ? 'агент' : 'клієнт'}`
                            }}
                          </span>
                      </button>
                    </template>
                    <template v-for="paidBy in ['client', 'agent', 'uinsure']">
                      <button
                        :key="`ipay_${paidBy}`"
                        v-if="isPaymentSystemEnable('ipay', paidBy)
                          && !$store.getters.USER.organizationId
                          && isAcquireCommissionMayBePaid('ipay', paidBy)
                          && !isPaymentWayUnavailable('ipay', paidBy)"
                        @click="showModalGetInvoiceOrder('ipay', paidBy)"
                        class="btn btn-warning payments-ways-btn"
                        type="button"
                      >
                          Оплатити через iPay
                          <span
                            v-if="isAcquireCommissionMayBePaid('ipay', paidBy)"
                            class="payment_notice"
                          >
                            {{ paidBy === 'uinsure'
                                ? 'Комісія не стягується'
                                : (isAcquireCommissionPayAgent(paidBy)
                                    ? 'Комісію ' + getAcquireCommission('ipay') + '% оплачує агент'
                                    : 'Комісію за еквайринг оплачує клієнт')
                            }}
                          </span>
                      </button>
                    </template>
                    <template v-for="paidBy in ['client', 'agent', 'uinsure']">
                      <button
                        :key="`hostpay_${paidBy}`"
                        v-if="isPaymentSystemEnable('hostpay', paidBy)
                          && !$store.getters.USER.organizationId
                          && isAcquireCommissionMayBePaid('hostpay', paidBy)
                          && !isPaymentWayUnavailable('hostpay', paidBy)"
                        @click="showModalGetInvoiceOrder('hostpay', paidBy)"
                        class="btn btn-warning payments-ways-btn"
                        type="button"
                      >
                          Оплатити через HostPay
                          <span
                            v-if="isAcquireCommissionMayBePaid('hostpay', paidBy)"
                            class="payment_notice"
                          >
                            {{ paidBy === 'uinsure'
                                ? 'Комісія не стягується'
                                : (isAcquireCommissionPayAgent(paidBy)
                                    ? 'Комісію ' + getAcquireCommission('hostpay') + '% оплачує агент'
                                    : 'Комісію за еквайринг оплачує клієнт')
                            }}
                          </span>
                      </button>
                    </template>
                    <template v-for="term in portmoneInstallmentTerms">
                      <template v-for="paidBy in ['client', 'agent', 'uinsure']">
                        <button
                          :key="`portmone_${term}_${paidBy}`"
                          v-if="!$store.getters.USER.organizationId && isPaymentSystemEnable('portmone', paidBy) && paySum >= PORTMONE_MIN_AMOUNT && isPortmoneCommissionMayBePaid(term, paidBy) && !isPaymentWayUnavailable('portmone', paidBy, term)"
                          @click="showModalGetPortmoneInstallment(term, paidBy)"
                          class="btn payments-ways-btn payments-ways-btn--portmone"
                          type="button"
                        >
                          <span class="payments-ways-btn--portmone__main">
                            <span class="payments-ways-btn--portmone__title">Розстрочка Portmone</span>
                            <span
                              v-if="isPortmoneCommissionMayBePaid(term, paidBy)"
                              class="payments-ways-btn--portmone__notice"
                            >
                              {{ paidBy === 'uinsure'
                                  ? 'Комісія не стягується'
                                  : `Комісію ${getPortmoneTermCommission(term)}% оплачує ${isAcquireCommissionPayAgent(paidBy) ? 'агент' : 'клієнт'}`
                              }}
                            </span>
                          </span>
                          <span class="payments-ways-btn--portmone__aside">
                            <span class="payments-ways-btn--portmone__badge">{{ getTermMonthsLabel(term) }}</span>
                            <span class="payments-ways-btn--portmone__chevron">›</span>
                          </span>
                        </button>
                      </template>
                    </template>
                    <button
                      v-if="$store.getters.USER.id != 545"
                      @click="showModalGetInvoiceLegal()"
                      class="btn btn-warning payments-ways-btn"
                      type="button"
                    >
                      Рахунок-фактура
                    </button>

                    <hr class="hr-grey">
                    <br/>
                    <br/>
                    <button class="btn-white" type="button" @click="close()">Скасування</button>
                    <div v-if="this.successMessage" class="stepThree">
                        <span class="successMessage">Посилання на оплату успішно скопійоване!</span>
                        <button class="btn-blue" type="button" @click="close()">Закрити</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import { getPaymentSystemsList } from '@/api/paymentSystem';
import { Pluralizer } from '@/shared/lib/string';

const { getPluralText } = Pluralizer();

export default {
  components: { VueSlider },
  name: 'DeclaredSuccess',
  props: [
    'isLegalType',
    'companyId',
    'programName'
  ],
  data() {
    return {
      paySum: 0,
      earningsSum: 0,
      paymentLink: null,
      orderId: null,
      orderData: null,
      successMessage: false,
      preloader: false,
      goToHref: '',
      legalType: false,
      money: {
        decimal: ',',
        thousands: ' ',
        prefix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
      },
      dialogVisible: false,
      paymentSystemsList: [],
      PORTMONE_MIN_AMOUNT: 500,
      unavailablePaymentWays: [],
    };
  },
  async created() {
    this.legalType = this.isLegalType;
    this.$eventBus.$on('payment-way-unavailable', this.markPaymentWayUnavailable);
  },
  beforeDestroy() {
    this.$eventBus.$off('payment-way-unavailable', this.markPaymentWayUnavailable);
  },
  computed: {
    portmoneInstallmentTerms() {
      return this.paymentSystemsList.find(item => item.code === 'portmone')?.partial_pay_periods ?? [];
    },
    portmonePaymentSystem() {
      return this.paymentSystemsList.find(item => item.code === 'portmone');
    },
  },
  methods: {
    close() {
      this.dialogVisible = false;
    },
    open: function (orderId, price, earnings, orderData) {
      this.successMessage = false;
      this.orderId = orderId;
      this.orderData = orderData;

      if (this.orderData) {
        this.legalType = (this.orderData.insurant?.customerTypeId == 2);
      }

      this.paySum = price;
      this.earningsSum = earnings;
      this.dialogVisible = true;
    },
    copyLink(){
      this.successMessage = true;
      this.$clipboard(this.paymentLink);
    },
    showModalGetInvoiceOrder(provider, paidBy) {
      const paymentSystem = this.paymentSystemsList.find(item => item.code === provider);

      const providerData = {
        'code': provider,
        'title': paymentSystem?.title ?? '',
        'percentage_acquiring': paymentSystem?.percentage_acquiring ?? 0,
        'paid_by': paidBy,
      };

      this.$emit('showModalGetInvoiceOrder', this.orderData, providerData);
      this.close();
    },
    showModalGetPortmoneInstallment(term, paidBy) {
      const paymentSystem = this.paymentSystemsList.find(item => item.code === 'portmone');

      const providerData = {
        'code': 'portmone',
        'title': `${paymentSystem?.title ?? 'Portmone'} (розстрочка ${term} міс.)`,
        'percentage_acquiring': this.getPortmoneTermCommission(term),
        'paid_by': paidBy,
        'invoiceType': 'portmone-installment',
        'term': term,
      };

      this.$emit('showModalGetInvoiceOrder', this.orderData, providerData);
      this.close();
    },
    showModalGetInstantLoan() {
      this.$emit('showModalGetInstantLoan', this.orderData);
      this.close();
    },
    showModalGetMonoPayParts() {
      this.$emit('showModalGetMonoPayParts', this.orderData);
      this.close();
    },
    showModalGetInvoiceLegal() {
      this.$emit('showModalGetInvoiceLegal', this.orderData);
      this.close();
    },
    getTermMonthsLabel(term) {
      return getPluralText(term, ['місяць', 'місяці', 'місяців']);
    },
    isPaymentSystemEnable(provider, paidBy) {
      const item = this.paymentSystemsList.find(item => item.code === provider);
      if (!item?.is_enabled) {
        return false;
      }

      const options = item.available_options ?? [];
      if (paidBy !== 'uinsure' && options.includes('uinsure')) {
        return false;
      }

      return options.includes(paidBy);
    },
    getAcquireCommission(provider) {
      return this.paymentSystemsList.find(item => item.code === provider)?.percentage_acquiring;
    },
    isAcquireCommissionPayAgent(paidBy) {
      return paidBy === 'agent';
    },
    isAcquireCommissionMayBePaid(provider, paidBy) {
      if (!this.isAcquireCommissionPayAgent(paidBy)) {
        return true;
      }

      const commissionPercent = this.getAcquireCommission(provider);
      if (commissionPercent <= 0) {
        return false;
      }

      const commissionSum = this.paySum * commissionPercent / 100;

      return this.earningsSum >= commissionSum;
    },
    getPortmoneTermCommission(term) {
      const ps = this.portmonePaymentSystem;
      const termData = (ps?.installment_terms ?? [])
        .find(item => Number(item.term_months) === Number(term));

      return Number(termData?.percentage_acquiring ?? ps?.percentage_acquiring ?? 0);
    },
    markPaymentWayUnavailable({ code, paidBy, term = null }) {
      if (!code) {
        return;
      }
      const exists = this.unavailablePaymentWays.some(item =>
        item.code === code
        && item.paidBy === paidBy
        && (item.term ?? null) === (term ?? null)
      );
      if (!exists) {
        this.unavailablePaymentWays.push({ code, paidBy, term: term ?? null });
      }
    },
    isPaymentWayUnavailable(code, paidBy, term = null) {
      return this.unavailablePaymentWays.some(item =>
        item.code === code
        && item.paidBy === paidBy
        && (item.term ?? null) === (term ?? null)
      );
    },
    isPortmoneCommissionMayBePaid(term, paidBy) {
      if (!this.isAcquireCommissionPayAgent(paidBy)) {
        return true;
      }

      const commissionPercent = this.getPortmoneTermCommission(term);
      if (commissionPercent <= 0) {
        return false;
      }

      return this.earningsSum >= this.paySum * commissionPercent / 100;
    }
  },
  watch: {
    companyId: {
      immediate: false,
      async handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.preloader = true;
          const response = await getPaymentSystemsList(this.companyId, this.programName);
          if (response.data) {
            this.paymentSystemsList = response.data;
          }
          this.preloader = false;
        }
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    overflow-y: auto;
    padding: 24px 12px;
    transition: opacity 0.3s ease;
}

.custom-modal-wrapper {
    display: block;
    margin: auto;
    width: 100%;
}

.custom-modal-container {
  width: 640px !important;
  max-width: 640px !important;
  height: auto !important;
  background: #FFFFFF;
  border-radius: 6px;
  margin: 0 auto;
  box-shadow: 0 24px 60px rgba(17, 24, 39, .18);
  transition: all 0.3s ease;

    .hr-grey {
        width: 100%;
        height: 1px;
        border: none;
        background: #e6e8eb;
        margin: 0 0 26px;
    }
    .btn.btn-warning + .hr-grey {
        margin: 26px 0 34px;
    }
    .hr-grey + br,
    .hr-grey + br + br {
        display: none;
    }
    .policy-link {
        width: 436px;
        height: 64px;
        background: #F6F7FB;
        border-radius: 5px;
        display: flex;
        @media (max-width: 992px) {
            width: 300px;
        }

        .link {
            margin: auto 0 auto 12px;
            white-space: nowrap;
            overflow: hidden;
            max-width: 67%;
            padding: 5px;
            text-overflow: ellipsis;

            @media (max-width: 992px) {
                margin: auto 0 auto 2px;
            }
        }
    }
    .message {
        width: 258px; height: 29px;font-family: Circe,serif;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 29px;
        text-align: center;
        color: #24282C;

        @media (max-width: 992px) {
            width: 258px;
            height: 21px;
            font-size: 17px;
            line-height: 20px;
        }
    }

    .mtsbu-icon {
        margin: auto 0 auto 20px;

        @media (max-width: 992px) {
            margin: auto 0 auto 5px;
        }
    }

    .payments-ways-btn {
        width: 100%;
        max-width: none;
        background-color: #f5a01e;
        border: none;
        border-radius: 5px;
        font-weight: 700;
        font-size: 19px;
        line-height: 1.2;
        color: #fff;
        padding: 12px 16px;
        margin-top: 7px;
        margin-bottom: 7px;
        transition: transform .16s ease, box-shadow .16s ease;
        .payments-icon {
            float: left;
        }
        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 8px 18px rgba(245, 160, 30, .35);
        }
        @media (max-width: 600px) {
            font-size: 16px;
        }
    }
    .payments-ways-btn.disable{
        background-color: #c0c0c0;
        border-color: #c0c0c0;
    }
    .payments-ways-btn.payments-ways-btn--light-blue {
        background-color: #009BEB;
    }
    .payments-ways-btn.payments-ways-btn--portmone {
        display: inline-flex;
        vertical-align: top;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 18px 20px 18px 24px;
        background-color: #0a8fd0;
        background-image: linear-gradient(180deg, #12a7ec 0%, #0a8fd0 100%);
        box-shadow: 0 6px 16px rgba(10, 143, 208, .32), inset 0 1px 0 rgba(255, 255, 255, .28);

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 10px 22px rgba(10, 143, 208, .4), inset 0 1px 0 rgba(255, 255, 255, .3);
        }

        .payments-ways-btn--portmone__main {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
            text-align: left;
        }
        .payments-ways-btn--portmone__title {
            font-weight: 700;
            font-size: 18px;
            line-height: 1.2;
            color: #fff;

            @media (max-width: 600px) {
                font-size: 16px;
            }
        }
        .payments-ways-btn--portmone__notice {
            font-weight: 600;
            font-size: 12px;
            line-height: 1.2;
            color: rgba(255, 255, 255, .9);
        }
        .payments-ways-btn--portmone__aside {
            display: flex;
            align-items: center;
            gap: 10px;
            flex: 0 0 auto;
        }
        .payments-ways-btn--portmone__badge {
            font-weight: 700;
            font-size: 12px;
            line-height: 1;
            letter-spacing: .04em;
            text-transform: uppercase;
            white-space: nowrap;
            color: #0b6f9e;
            background: #fff;
            padding: 7px 11px;
            border-radius: 999px;
        }
        .payments-ways-btn--portmone__chevron {
            font-weight: 700;
            font-size: 18px;
            line-height: 1;
            color: #fff;
            opacity: .85;
        }
    }
    .payments-ways-btn .label {
        position: absolute;
        right: 1px;
        top: 1px;
        z-index: 2;
        color: #EF4137;
        text-transform: uppercase;
        text-align: center;
        font-size: 10px;
        line-height: normal;
        font-weight: bold;
        height: 15px;
        padding: 0 4px;
        border: 1px solid #EF4137;
        border-radius: 3px;
    }

    @media (max-width: 992px) {
        width: 95% !important;
        max-width: 460px !important;
    }

    ::v-deep .policy-bill {
        padding: 36px 44px 44px;
        position: relative;

        @media (max-width: 600px) {
            padding: 24px 18px 28px;
        }
    }

    ::v-deep .policy-bill__heading {
        margin: 14px 0 26px;
        font-size: 30px;
        font-weight: 700;
        line-height: 1.2;
        color: #1a1a1a;
    }

    ::v-deep .btn-white {
        height: auto;
        padding: 16px 24px;
        border-radius: 5px;
        border: 1px solid #d8dde2;
        background: #fff;
        color: #0d9ae5;
        font-weight: 600;
        font-size: 16px;
        transition: background .16s ease, border-color .16s ease;

        &:hover {
            background: #f4fafe;
            border-color: #0d9ae5;
        }
    }
}

.custom-modal-custom-header h3 {
    margin-top: 0;
    color: #42b983;
}

.custom-modal-body {
    margin: 20px 0;
}

.modal-default-button {
    float: right;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .custom-modal-container,
.modal-leave-active .custom-modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.payment_notice {
    display: block;
    margin-top: 5px;
    font-size: 13px;
    line-height: 1.2;
    font-weight: 600;
    color: #0d9ae5;
}
</style>
